import { TransactionKind } from '../clients/LedgerScannerClient'
import { SwapProvider } from './swapInterface'

export enum TransactionStatus {
  Pending = 'Pending',
  Confirmed = 'Confirmed',
  Failed = 'Failed',
}

export interface TransactionActivity {
  kind: TransactionKind
  transactionId: number | string
  currency?: string
  type: 'send' | 'receive'
  senderAddress: string
  receiverAddress: string
  amount: number
  memo: string | null
  timestamp: Date
  tokenLedgerId: string
  chain?: string
  status: TransactionStatus
  logo?: string
  decimals?: number
}

export enum SwapActionType {
  DecreaseLiquidity = 'decreaseLiquidity',
  LimitOrder = 'limitOrder',
  Claim = 'claim',
  Swap = 'swap',
  AddLiquidity = 'addLiquidity',
  TransferPosition = 'transferPosition',
  IncreaseLiquidity = 'increaseLiquidity',
}

export interface Swap {
  provider: SwapProvider.ICPSWAP | SwapProvider.KONGSWAP | SwapProvider.ODIN
  fee: number | null
  timestamp: number
  token0: string
  token1: string
  token0Amount: string
  token1Amount: string
  slippage: string | null
  amountUSD: number | null
  token0Price: number | null
  token1Price: number | null
  exchangeRate: string | null
  liquidityChange: number | null
  action_type: SwapActionType
}

interface ExchangeActivityToken {
  symbol: string
  logo: string
}

export enum ExchangeProvider {
  ICPSwap = 'ICPSwap',
  ICDex = 'ICDex',
  StealthEx = 'StealthEX',
  KongSwap = 'KongSwap',
}

export interface ExchangeActivity {
  exchangeId: string
  fromToken: ExchangeActivityToken
  toToken: ExchangeActivityToken
  fromAmount: string
  toAmount: string
  timestamp: Date
  provider: ExchangeProvider
  wallet: string
  status?: string
}
